'use strict';

// Client details form (name, contact details etc.) used in the Project form and the Contact Us page


const _ = require('lodash');
const Classnames = require('classnames');
const React = require('react');
const ReactDOM = require('react-dom');
var Reflux = require('reflux');

const isNode = typeof document === 'undefined';
if (!isNode) {
    require('./contact-form.scss');
}

const Forms = require('../forms');
const Global = require('../global');
var Store = require('../store').Store;
var Actions = require('../store').Actions;

var ResponsiveMixin = Global.ResponsiveMixin;

const EssentialDetails = React.createClass({
    mixins: [ Global.ResponsiveMixin ],

    propTypes: {
        compact: React.PropTypes.bool,
    },
    getDefaultProps: function() {
        return {
            compact: false,
        };
    },

    validate: function() {
        const fields = ['firstname', 'lastname', 'email', 'phone', 'job', 'company', 'city', 'region'];

        // Return false if any field fails validation
        return (!_.some(fields, f => {
            // Value of the field
            const v = this.refs[f].state.value;

            // Custom validator - e.g. this.validateEmail
            const validator = this.refs[f].props.validator;

            // Custom validator fails?
            if (v && typeof validator === 'function' && !validator(v)) {
                return true;  // returning true means the test failed
            }

            // Fail if value is not set
            if (this.refs[f].props.required && !v) {
                return true;  // returning true means the test failed
            }

            return false;  // return false means the validation passed
        }))
        // validate() returning false means it's invalid
    },
    validateEmail: function(v) {
        return v.indexOf('@') != -1;  // returning false means it's invalid
    },
    render: function() {
        const regions = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN',
                         'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV',
                         'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN',
                         'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

        const alert = this.props.alert;

        /* autocomplete is implemented as follows (disabled as broken on Chrome with React controlled inputs):
        const firstname = <... autocomplete='given-name'    
        const lastname  = <... autocomplete='family-name'   
        const email     = <... autocomplete='email'         
        const phone     = <... autocomplete='tel'           
        const position  = <... autocomplete=''              
        const company   = <... autocomplete=''              
        const city      = <... autocomplete='address-level2'
        const region    = <... autocomplete='address-level1'
        */

        const firstname = <Forms.Input keyname='firstname' label='FIRST NAME' ref='firstname' required alert={alert} placeholder='FIRST NAME' showLabel={this.state.viewportLayout != 'desktop'} showPlaceholder={this.state.viewportLayout == 'desktop'} />;
        const lastname  = <Forms.Input keyname='lastname'  label='LAST NAME'  ref='lastname'  required alert={alert} placeholder='LAST NAME'  showLabel={this.state.viewportLayout != 'desktop'} showPlaceholder={this.state.viewportLayout == 'desktop'} />;
        const email     = <Forms.Input keyname='email'     label='EMAIL'      ref='email'     required alert={alert} validator={this.validateEmail} />;
        const phone     = <Forms.Input keyname='phone'     label='PHONE'      ref='phone'     required alert={alert} />;
        const position  = <Forms.Input keyname='job'       label='POSITION'   ref='job'       required alert={alert} />;
        const company   = <Forms.Input keyname='company'   label='COMPANY'    ref='company'   required alert={alert} />;
        const city      = <Forms.Input keyname='city'      label='CITY'       ref='city'      required alert={alert} />;
        const region    = <Forms.Select keyname='region'   label='STATE'      ref='region'    required alert={alert} options={regions} />;


        const row_classes = Classnames({
            'form-field': true,
            'form-field-stacked': this.props.compact,
        });
        const inline_classes = row_classes + ' form-field-inline';

        return (
            <div className='contact-essentialDetails'>
                {this.state.viewportLayout == 'desktop' ?
                    <div className={inline_classes}>
                        <label>NAME</label>
                        {firstname}
                        {lastname}
                    </div>
                :
                    <div>
                        <div className={row_classes}>
                            {firstname}
                        </div>
                        <div className={row_classes}>
                            {lastname}
                        </div>
                    </div>
                }
                <div className={row_classes}>
                    {email}
                </div>
                <div className={row_classes}>
                    {phone}
                </div>
                {this.props.compact ?
                    (
                        this.state.viewportLayout == 'desktop' ?
                            <div className={inline_classes}>
                                {position}
                                {company}
                            </div>
                        :
                            <div>
                                <div className={row_classes}>
                                    {position}
                                </div>
                                <div className={row_classes}>
                                    {company}
                                </div>
                            </div>
                    )
                :
                    <div>
                        <div className={row_classes}>
                            {position}
                        </div>
                        <div className={row_classes}>
                            {company}
                        </div>
                    </div>
                }
                {this.props.compact ?
                    (
                        this.state.viewportLayout == 'desktop' ?
                            <div className={inline_classes}>
                                {city}
                                {region}
                            </div>
                        :
                            <div>
                                <div className={row_classes}>
                                    {city}
                                </div>
                                <div className={row_classes}>
                                    {region}
                                </div>
                            </div>
                    )
                :
                    <div>
                        <div className={row_classes}>
                            {city}
                        </div>
                        <div className={row_classes}>
                            {region}
                        </div>
                    </div>
                }
            </div>
        );
    },
});

const DescriptionField = React.createClass({
    mixins: [ ResponsiveMixin, Reflux.connect(Store, 'store') ],

    save: function(keyname, event) {
        Actions.setProjectField(keyname, event.target.value);
    },
    render: function() {
        return (
            <div className='contact-descriptionField'>
                <label htmlFor='desc'>
                    {/*DESCRIBE YOUR FURNITURE REQUIREMENTS AND PROJECT SCOPE*/}
                    BRIEFLY DESCRIBE YOUR PROJECT NEEDS
                </label>
                <textarea className    = { Classnames({
                                             'pf-expanded': this.props.expanded
                                         })}
                          name         = 'desc'
                          onChange     = {this.save.bind(null, 'desc')}
                          defaultValue = {this.state.store.fields.desc} />
            </div>
        );
    },
});

module.exports = {
    EssentialDetails: EssentialDetails,
    DescriptionField: DescriptionField,
};



// WEBPACK FOOTER //
// ./src/components/contact-form.jsx